export const backdropSx = {
  backdropFilter: 'blur(1.5px)',
  background: 'rgba(255, 255, 255, 0.20)',
};
